import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IAbsenceReason } from "../../utils/types/models";

export default createEntityReducer<IAbsenceReason>(Endpoint.AbsenceReasons, Endpoint.AbsenceReasonsList);
